'use client';
import {
  ChartsZoomSlider,
  type ChartsAxisZoomSliderThumbClasses,
  type ChartsAxisZoomSliderThumbClassKey,
  chartsAxisZoomSliderThumbClasses,
  type ChartsAxisZoomSliderTrackClasses,
  type ChartsAxisZoomSliderTrackClassKey,
  chartsAxisZoomSliderTrackClasses,
} from '../ChartsZoomSlider';

/**
 * @deprecated Use `ChartsZoomSlider` instead. We added S to the charts prefix to align with other components.
 */
export const ChartZoomSlider = ChartsZoomSlider;

/**
 * @deprecated Use `ChartsAxisZoomSliderThumbClasses` instead. We added S to the charts prefix to align with other components.
 */
export type ChartAxisZoomSliderThumbClasses = ChartsAxisZoomSliderThumbClasses;

/**
 * @deprecated Use `ChartsAxisZoomSliderThumbClassKey` instead. We added S to the charts prefix to align with other components.
 */
export type ChartAxisZoomSliderThumbClassKey = ChartsAxisZoomSliderThumbClassKey;

/**
 * @deprecated Use `ChartsAxisZoomSliderTrackClasses` instead. We added S to the charts prefix to align with other components.
 */
export type ChartAxisZoomSliderTrackClasses = ChartsAxisZoomSliderTrackClasses;

/**
 * @deprecated Use `ChartsAxisZoomSliderTrackClassKey` instead. We added S to the charts prefix to align with other components.
 */
export type ChartAxisZoomSliderTrackClassKey = ChartsAxisZoomSliderTrackClassKey;

/**
 * @deprecated Use `chartsAxisZoomSliderThumbClasses` instead. We added S to the charts prefix to align with other components.
 */
export const chartAxisZoomSliderThumbClasses = chartsAxisZoomSliderThumbClasses;

/**
 * @deprecated Use `chartsAxisZoomSliderTrackClasses` instead. We added S to the charts prefix to align with other components.
 */
export const chartAxisZoomSliderTrackClasses = chartsAxisZoomSliderTrackClasses;
